/* Tabs (product focus, ingredients) and horizontal carousels (ingredients, reviews). */
(function () {
  document.querySelectorAll('[data-vf-tabs]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vf-tab]'); if (!t || !root.contains(t)) return;
      var key = t.dataset.vfTab;
      root.querySelectorAll('[data-vf-tab]').forEach(function (b) { var on = b.dataset.vfTab === key; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-vf-tab-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.vfTabPanel === key); });
      root.querySelectorAll('[data-vf-track]').forEach(update);
    });
  });
  function update(track) {
    var bar = track.parentElement.querySelector('[data-vf-fill]'); if (!bar) return;
    var max = track.scrollWidth - track.clientWidth; var ratio = track.clientWidth / track.scrollWidth;
    bar.style.width = Math.max(ratio * 100, 8) + '%';
    bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (100 / ratio - 100) : 0) + '%)';
  }
  document.querySelectorAll('[data-vf-track]').forEach(function (track) {
    var wrap = track.parentElement; var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : 320; };
    wrap.querySelector('[data-vf-next]') && wrap.querySelector('[data-vf-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    wrap.querySelector('[data-vf-prev]') && wrap.querySelector('[data-vf-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { update(track); }, { passive: true });
    window.addEventListener('resize', function () { update(track); });
    update(track);
  });
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('[data-vf-track]').forEach(update); });
})();

/* Hero drip: run one fall per background-video loop. The animation restarts whenever the video starts or wraps around. */
(function () {
  document.querySelectorAll('[data-vf-drip]').forEach(function (d) {
    var hero = d.closest('.vf-hero'); var v = hero && hero.querySelector('.vf-hero__video'); if (!v) return;
    var last = 0, loops = 0, every = Math.max(1, parseInt(d.dataset.vfDrip, 10) || 1);
    function setDur() { if (v.duration && isFinite(v.duration)) d.style.setProperty('--drip-dur', (v.duration * every) + 's'); }
    function restart() { loops = 0; d.style.animation = 'none'; void d.offsetWidth; d.style.animation = ''; }
    v.addEventListener('loadedmetadata', setDur); setDur();
    v.addEventListener('play', function () { setDur(); if (v.currentTime < 0.5) restart(); });
    v.addEventListener('timeupdate', function () { if (v.currentTime < last - 0.5) { loops += 1; if (loops % every === 0) restart(); } last = v.currentTime; });
  });
})();

/* Live Instagram feed for the community strip: fetches the proxy JSON and rebuilds the tiles.
   The photo blocks stay as the fallback when the feed is empty or unreachable. */
(function () {
  document.querySelectorAll('[data-vf-feed]').forEach(function (section) {
    var track = section.querySelector('[data-vf-track]'), tpl = section.querySelector('[data-vf-feed-tile]');
    if (!track || !tpl) return;
    var url = section.getAttribute('data-vf-feed'), count = parseInt(section.getAttribute('data-vf-feed-count'), 10) || 8;
    var label = section.getAttribute('data-vf-feed-label') || '', keep = section.getAttribute('data-vf-feed-keep') === '1';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'limit=' + count, { mode: 'cors', credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }).then(function (data) {
      var items = (data && data.items || []).filter(function (m) { return m && m.media_url && m.permalink; }).slice(0, count);
      if (!items.length) return;
      var frag = document.createDocumentFragment();
      items.forEach(function (m) {
        var tile = tpl.content.firstElementChild.cloneNode(true), img = tile.querySelector('img'), chip = tile.querySelector('.vf-community__chip');
        tile.href = m.permalink; img.src = m.media_url; img.alt = m.caption || 'Instagram post';
        if (label) { chip.hidden = false; chip.querySelector('[data-vf-feed-chip]').textContent = label; tile.classList.add('vf-community__tile--hover'); }
        if (m.media_type === 'VIDEO') tile.classList.add('vf-community__tile--video');
        frag.appendChild(tile);
      });
      if (!keep) track.querySelectorAll('.vf-community__tile').forEach(function (t) { t.remove(); });
      track.appendChild(frag);
      section.classList.add('vf-community--live');
      track.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    }).catch(function () { /* keep the block photos */ });
  });
})();
